<template>
  <nuttrema-layout-form-standard :edit="edit" :theme="theme" :saveError="PersonDetails.saveError">
    <template slot="center">

      <el-form
         label-width="20em"
        :ref="formRef"
        :model="formData"
        :rules="rules"
        :label-position="labelPosition">

        <section>
          <h4 class="section-title">{{ $t('label.basic') }}</h4>
          <div class="section-items">
            <el-form-item :label="$t('label.title')" prop="personal_title">
              <el-col :span="6" :xs="12">
                <el-input v-model="formData.personal_title" :disabled="!edit"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.first_name')" prop="first_name">
              <el-col class="el-col--min-21em" :span="12">
                <el-input v-model="formData.first_name" :disabled="!edit"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.last_name')" prop="last_name">
              <el-col class="el-col--min-21em" :span="12">
                <el-input v-model="formData.last_name" :disabled="!edit"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.date_of_birth')" prop="date_of_birth">
              <el-col class="el-col--min-15em" :span="6">
                <el-date-picker type="date" class="w-100" :placeholder="$t('label.pick_a_date')" v-model="formData.date_of_birth" :disabled="!edit" format="dd/MM/yyyy" value-format="yyyy-MM-dd"></el-date-picker>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.gender')" prop="gender">
              <el-col class="el-col--min-15em" :span="6">
                <el-select v-model="formData.gender" class="w-100" :placeholder="$t('label.select_gender')" :disabled="!edit">
                  <el-option :label="$t('label.male')" value="male"></el-option>
                  <el-option :label="$t('label.female')" value="female"></el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </div>
        </section>

        <section>
          <h4 class="section-title">{{ $t('label.person_life_stage_legend') }}</h4>
          <div class="section-items">
            <el-form-item :label="$t('label.life_stage')">
              <el-col class="el-col--min-17em" :span="6">
                <el-cascader
                   v-model="formData.person_life_stage_id"
                   class="w-100"
                  :disabled="!edit"
                  :clearable="edit"
                  :filterable="true"
                  :options="_get(PersonLifeStages, 'data', [])"
                  :props="{ label: 'title', value: 'id', children: 'SubCategories' }"
                  :show-all-levels="false">
                </el-cascader>
              </el-col>
              <el-col :span="24">
                <div class="el-form-item__help">
                  <p v-html="_markdown.render($t('label.person_life_stage_help'))"></p>
                </div>
              </el-col>
            </el-form-item>
          </div>
        </section>

        <section>
          <h4 class="section-title">{{ $t('label.contact') }}</h4>
          <div class="section-items">

            <el-form-item v-show="!_get(PersonDetails, 'data.account_activated')" :label="$t('label.offline_user')" prop="offline_user" :class="{ 'is-inline': !id }">
              <el-switch v-model="formData.offline_user" :disabled="!edit || _get(PersonDetails, 'data.account_activated')"></el-switch>
            </el-form-item>

            <el-form-item v-show="!formData.offline_user" :label="$t('label.email')" prop="email">
              <el-col  class="el-col--min-21em" :span="12">
                <el-input v-model="formData.email" :disabled="!edit || _get(PersonDetails, 'data.account_activated')"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.phone')" prop="phone">
              <el-col  class="el-col--min-21em" :span="12">
                <el-input v-model="formData.phone" :disabled="!edit"></el-input>
              </el-col>
              <el-col :span="24">
                <p class="el-form-item__help" style="padding: 0.5em">{{ $t('label.phone_format_placeholder') }}</p>
              </el-col>
            </el-form-item>
          </div>
        </section>

        <section>
          <h4 class="section-title">{{ $t('label.regional_settings') }}</h4>
          <div class="section-items">
            <el-form-item :label="$t('label.preffered_language')">
              <el-col  class="el-col--min-17em" :span="8">
                <el-select v-model="formData.language_id" class="w-100" :disabled="!edit">
                  <el-option v-for="language in _get(RegionalAndLanguageAll, 'data.Languages', [])"
                    :label="language.native_name"
                    :value="language.id"
                    :key="language.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.measurement_system')">
              <el-col class="el-col--min-17em" :span="8">
                <el-select v-model="formData.measurement_system_id" class="w-100" :disabled="!edit">
                  <el-option v-for="measurementSystem in _get(RegionalAndLanguageAll, 'data.MeasurementSystems', [])"
                    :label="measurementSystem.name"
                    :value="measurementSystem.id"
                    :key="measurementSystem.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.time_zone')">
              <el-col class="el-col--min-17em" :span="8">
                <el-cascader
                   v-model="formData.time_zone_id"
                   class="w-100"
                  :disabled="!edit"
                  :filterable="true"
                  :options="_get(RegionalAndLanguageAll, 'data.TimeZones', [])"
                  :props="{ label: 'title', value: 'id', children: 'Zones' }"
                  :show-all-levels="true">
                </el-cascader>
              </el-col>
            </el-form-item>
          </div>
        </section>


        <section>
            <h4 class="section-title">{{ $t('label.address') }}</h4>
            <div class="section-items">

              <el-form-item :label="$t('label.street')" prop="street">
                <el-col :span="14">
                    <el-input v-model="formData.PersonData.address_street.value" :placeholder="$t('label.street')" :disabled="!edit"></el-input>
                </el-col>
                <el-col :span="6" :offset="1">
                    <el-input v-model="formData.PersonData.address_house_no.value" :placeholder="$t('label.house_no')" :disabled="!edit"></el-input>
                </el-col>
              </el-form-item>

              <el-form-item :label="$t('label.city')" prop="city">
                <el-col :span="14">
                  <el-input v-model="formData.PersonData.address_city.value" :placeholder="$t('label.city')" :disabled="!edit"></el-input>
                </el-col>
                <el-col :span="6" :offset="1">
                    <el-input v-model="formData.PersonData.address_zip.value" :placeholder="$t('label.zip')" :disabled="!edit"></el-input>
                </el-col>
              </el-form-item>

              <el-form-item :label="$t('label.country')">
                <el-col  class="el-col--min-17em" :span="8">
                  <el-cascader
                     v-model="formData.region_id"
                     class="w-100"
                    :disabled="!edit"
                    :clearable="edit"
                    :filterable="true"
                    :options="_get(RegionalAndLanguageAll, 'data.Regions', [])"
                    :props="{ label: 'title', value: 'id', children: 'SubRegions' }"
                    :show-all-levels="false">
                  </el-cascader>
                </el-col>
              </el-form-item>
            </div>
          </section>

      </el-form>
    </template>

    <template slot="footer">
      <nav class="footer-row">
        <el-button
           type="primary"
           size="small"
          :disabled="!isDataChanged"
          :loading="isSaving"
          @click="submitForm('formData')">
            <template v-if="id">{{ $t('label.save_changes') }}</template>
            <template v-else>{{ $t('label.add_new') }}</template>
        </el-button>

        <el-button v-if="id" type="text" size="small" @click="cancelChanges">
          <span v-if="showDoneButton">{{ $t('label.done') }}</span>
          <span v-else>{{ $t('label.cancel') }}</span>
        </el-button>
      </nav>
    </template>
  </nuttrema-layout-form-standard>
</template>

<script>
/* eslint-disable object-shorthand */
import { pick, assign, has, last, omitBy, isNil, get, merge, cloneDeep } from 'lodash';

import { validateDate, validatePhoneE164 } from 'helpers';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

import NuttremaGroupAndSort from 'components/ui/panels/nuttrema-panel-group-and-sort';
import UserInfoSmallCard from 'components/ui/card/user-info-small-card';

export default {
  name: 'form-participant-personal-information-cred',
  mixins: [FormStandardBehavior],
  props: {
    id: {
      default: null,
    },
    PersonDetails: {
      required: false,
      default: null,
    },
    RegionalAndLanguageAll: {
      required: true,
      default: null,
    },
    PersonLifeStages: {
      required: true,
      default: null,
    },
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
    theme: {
      type: String,
      required: false,
      default: null,
    },
    labelPosition: {
      type: String,
      required: false,
      default: 'right',
    },
  },
  components: {
    UserInfoSmallCard,
    NuttremaGroupAndSort,
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      deleteDialogVisible: false,
      originalData: {},
      formData: {
        personal_title: null,
        first_name: null,
        last_name: null,
        date_of_birth: null,
        gender: null,
        email: null,
        offline_user: false,
        phone: null,
        region_id: [],
        person_life_stage_id: [],
        time_zone_id: [],
        language_id: null,
        measurement_system_id: null,
        PersonData: {
          address_street: {
            section: 'address',
            key: 'street',
            value: null,
          },
          address_house_no: {
            section: 'address',
            key: 'house_no',
            value: null,
          },
          address_city: {
            section: 'address',
            key: 'city',
            value: null,
          },
          address_zip: {
            section: 'address',
            key: 'zip',
            value: null,
          },
        },
      },
      imageUrl: '',
      deleteData: {
        confirm: false,
        removeAssigned: false,
      },
      rules: {
        first_name: [
          {
            required: true,
            message: this.formatValidationMessage('validation.required', 'label.first_name', true),
            trigger: 'blur',
          },
        ],
        last_name: [
          {
            required: true,
            message: this.formatValidationMessage('validation.required', 'label.last_name', true),
            trigger: 'blur',
          },
        ],
        date_of_birth: [
          {
            required: true,
            message: this.formatValidationMessage('validation.required', 'label.date_of_birth', true),
            trigger: 'blur',
          },
          {
            validator: validateDate,
            message: this.formatValidationMessage('validation.invalid_date'),
            trigger: 'blur',
          },
        ],
        gender: [
          {
            required: true,
            message: this.formatValidationMessage('validation.required', 'label.gender', true),
            trigger: 'blur',
          },
        ],
        phone: [
          {
            trigger: 'blur',
            validator: this.validatePhone,
            message: this.formatValidationMessage('validation.invalid', 'label.phone_format', true),
          },
        ],
      },
    };
  },
  methods: {
    validatePhone(rule, value, callback) {
      if (!validatePhoneE164(value)) return callback(new Error());
      return callback();
    },
    getFormData() {
      const copy = this.clone(this.formData);

      // remove email from payload if user is offline
      if (get(copy, 'offline_user') && get(this.PersonDetails, 'data.status') === 'active') copy.email = null;

      const data = this.removeEmpty(copy);

      if (has(data, 'person_life_stage_id')) data.person_life_stage_id = last(data.person_life_stage_id);
      if (has(data, 'time_zone_id')) data.time_zone_id = last(data.time_zone_id);
      if (has(data, 'region_id')) data.region_id = last(data.region_id);

      return data;
    },
    setFormData() {
      if (has(this.PersonDetails, 'data.id')) {
        assign(
          this.formData,
          pick(omitBy(this.PersonDetails.data, isNil), [
            'personal_title',
            'first_name',
            'last_name',
            'email',
            'date_of_birth',
            'offline_user',
            'phone',
            'gender',
            'region_id',
            'person_life_stage_id',
            'language_id',
            'time_zone_id',
            'measurement_system_id',
          ]),
        );

        merge(this.formData.PersonData, get(this.PersonDetails, 'data.PersonData', {}));

        this.originalData = cloneDeep(this.formData);
      }
    },
  },
  created() {
    this.stateData = this.PersonDetails;
    this.formRef = 'participant-personal-information';
    this.setFormData();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/participant-cred/form-participant-personal-information-cred.vue